import React from "react";

function Ebikes({bikeone, biketwo}) {
    console.log(biketwo)
    return (
        <div className="bg-white compare-specs rounded p-3">
            <h5>Engine and Performance</h5>
            <div style={{overflow : 'scroll'}}>
            <table class="table table-bordered">
                <tbody>
                      <tr>
                        <td className="text-start">Name</td>
                        <td className="bg-light text-danger fw-bold">{bikeone?.title}</td>
                        <td className="bg-light text-danger fw-bold">{biketwo?.title}</td>
                    </tr>
                    <tr>
                        <td className="text-start">Motor Power</td>
                        <td>{bikeone?.bike_specification?.motor_power}</td>
                        <td>{biketwo?.bike_specification?.motor_power}</td>
                    </tr>
                    <tr>
                        <td className="text-start">Battery Capacity</td>
                         <td>{bikeone?.bike_specification?.battery_capacity}</td>
                        <td>{biketwo?.bike_specification?.battery_capacity}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Charging Time</td>
                        <td>{bikeone?.bike_specification?.charging_time}</td>
                        <td>{biketwo?.bike_specification?.charging_time}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Wheel Size</td>
                         <td>{bikeone?.bike_specification?.wheel_size}</td>
                        <td>{biketwo?.bike_specification?.wheel_size}</td>
                    </tr>
                     <tr>
                        <td className="text-start">App Connectivity</td>
                         <td>{bikeone?.bike_specification?.app_connectivity}</td>
                        <td>{biketwo?.bike_specification?.app_connectivity}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Load Capacity</td>
                         <td>{bikeone?.bike_specification?.load_capacity}</td>
                        <td>{biketwo?.bike_specification?.load_capacity}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Suspension</td>
                         <td>{bikeone?.bike_specification?.suspension}</td>
                        <td>{biketwo?.bike_specification?.suspension}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Foldable</td>
                         <td>{bikeone?.bike_specification?.foldable === 0 ? 'No' : 'Yes'}</td>
                        <td>{biketwo?.bike_specification?.foldable === 0 ? 'No' : 'Yes'}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Display Type</td>
                         <td>{bikeone?.bike_specification?.display_type}</td>
                        <td>{biketwo?.bike_specification?.display_type}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Top Speed</td>
                         <td>{bikeone?.bike_specification?.top_speed}</td>
                        <td>{biketwo?.bike_specification?.top_speed}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Range Per Charge</td>
                         <td>{bikeone?.bike_specification?.range_per_charge}</td>
                        <td>{biketwo?.bike_specification?.range_per_charge}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Frame Material</td>
                         <td>{bikeone?.bike_specification?.frame_material}</td>
                        <td>{biketwo?.bike_specification?.frame_material}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Bike Weight</td>
                         <td>{bikeone?.bike_specification?.bike_weight}</td>
                        <td>{biketwo?.bike_specification?.bike_weight}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Brake Type</td>
                         <td>{bikeone?.bike_specification?.brake_type}</td>
                        <td>{biketwo?.bike_specification?.brake_type}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Assist Modes</td>
                        <td>{bikeone?.bike_specification?.gears}/{bikeone?.bike_specification?.assist_modes}</td>
                        <td>{biketwo?.bike_specification?.gears}/{biketwo?.bike_specification?.assist_modes}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Water Resistence Rating</td>
                        <td>{bikeone?.bike_specification?.water_resistance_rating}</td>
                        <td>{biketwo?.bike_specification?.water_resistance_rating}</td>
                    </tr>
                     <tr>
                        <td className="text-start">Lighting</td>
                        <td>{bikeone?.bike_specification?.lighting}</td>
                        <td>{biketwo?.bike_specification?.lighting}</td>
                    </tr>
                     

                </tbody>
            </table>
            </div>
        </div>
    )
}

export default Ebikes;